// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221446/js/" + chunkId + "." + {"44":"0dd18088","225":"e5c91de2","481":"2b50f71c","486":"18bf7f4e","770":"aae8b4da"}[chunkId] + ".0.546839186488348.chunk.js";
};